// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__yIcYA","footer":"ModalCreateQualiphyProcedure_footer__3B1FN","additionData":"ModalCreateQualiphyProcedure_additionData__2P15f"};